import { Routes } from '@angular/router';
import { mainMenuRoutes } from './pages/main/main.routes';
import { Capacitor } from '@capacitor/core';

const isNative = Capacitor.isNativePlatform();

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'main',
    pathMatch: 'full',
  },
  {
    path: 'native',
    redirectTo: 'main/native'
  },
  {
    path: 'main',
    children: mainMenuRoutes,
    loadComponent: () =>
      import('./pages/main/main.page').then((m) => m.MainPage),
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./pages/informations/privacy-policy/privacy-policy.page').then(
        (m) => m.PrivacyPolicyPage
      ),
  },
  {
    path: 'forgot-password',
    redirectTo: 'main/forgot-password',
  },
  {
    path: 'signup',
    redirectTo: 'main/signup',
  },
  {
    path: 'signin',
    redirectTo: 'main/signin',
  },
  {
    path: 'verification',
    redirectTo: 'main/verification'
  },
  {
    path: 'reset-password',
    redirectTo: 'main/reset-password',
  },
  {
    path: 'search',
    redirectTo: 'main/search',
  },
  {
    path: 'distributor',
    redirectTo: 'main/distributor',
  },
  {
    path: 'cart',
    redirectTo: isNative ? 'main/native/cart' : 'main/cart',
  },
  {
    path: 'checkout',
    redirectTo: 'main/checkout',
  },
  {
    path: 'order/:id',
    redirectTo: 'main/order/:id',
  },
  {
    path: 'anticipate',
    redirectTo: 'main/anticipate',
  },
  {
    path: 'join',
    redirectTo: 'main/signup'
  },
  {
    path: 'info',
    redirectTo: 'main/info/:page',
  },
  {
    path: 'about-us',
    redirectTo: 'main/info/our_story',
  },
  {
    path: '**',
    redirectTo: 'main/page-not-found',
  }
];
